import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":plannerElementId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "planner-element-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
